import { createContext, useContext } from "react";

export type VideoFocusContextValue = {
  /** Id of the phone frame currently considered "in view", if any. */
  focusedId: string | null;
  setVisibility: (id: string, ratio: number) => void;
};

export const VideoFocusContext = createContext<VideoFocusContextValue | null>(
  null,
);

export function useVideoFocus(): VideoFocusContextValue {
  const context = useContext(VideoFocusContext);
  if (!context) {
    throw new Error("useVideoFocus must be used within VideoFocusProvider");
  }
  return context;
}
